/**
 * Created by mauget on 4/14/17.
 */
import {View} from 'backbone';
import template from 'dashboard/connections/connection-help.ejs';

class ConnectionHelpView extends View {

    initialize(opts){

        this.template = template;

        this.events = {

        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    render(){
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }


        this.delegateEvents();
        return this;
    }
}

export default ConnectionHelpView;
